import styled from "styled-components";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 33px;
  padding: 0 14px;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.85px);
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  transition: filter 0.15s ease, transform 0.15s ease;

  svg {
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    filter: brightness(1.15);
  }

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media (max-width: 375px) {
    height: 28px;
    font-size: 13px;
    padding: 0 12px;
  }
`;

const SelectImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M3.74969 14.2503L10.4015 7.59853C10.6985 7.30152 10.847 7.15301 11.0182 7.09737C11.1689 7.04842 11.3311 7.04842 11.4818 7.09737C11.653 7.15301 11.8015 7.30152 12.0985 7.59853L15.3039 10.8039M7.125 5.625C7.125 6.45343 6.45343 7.125 5.625 7.125C4.79657 7.125 4.125 6.45343 4.125 5.625C4.125 4.79657 4.79657 4.125 5.625 4.125C6.45343 4.125 7.125 4.79657 7.125 5.625ZM15.75 8.25C15.75 12.3921 12.3921 15.75 8.25 15.75C4.10786 15.75 0.75 12.3921 0.75 8.25C0.75 4.10786 4.10786 0.75 8.25 0.75C12.3921 0.75 15.75 4.10786 15.75 8.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SelectImageButton = ({
  onClick,
  disabled,
  label = "Select Image",
  className,
  type = "button",
  ...rest
}) => (
  <Button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={className}
    {...rest}
  >
    <SelectImageIcon />
    {label}
  </Button>
);

export default SelectImageButton;
